import React from 'react'
import Table from './compnent/Table'

const index = () => {
  return (
   <Table/>
  )
}

export default index